import { render } from "./question-panel.vue?vue&type=template&id=107fd0df&scoped=true&ts=true"
import script from "./question-panel.vue?vue&type=script&lang=ts"
export * from "./question-panel.vue?vue&type=script&lang=ts"

import "./question-panel.vue?vue&type=style&index=0&id=107fd0df&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107fd0df"]])

export default __exports__